import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=57c69339&scoped=true&"
import script from "./PhoneNumber.vue?vue&type=script&lang=js&"
export * from "./PhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&id=57c69339&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c69339",
  null
  
)

export default component.exports